

export class SelectedPortOutput implements ISelectedPortOutput {
    /** The auto-generated id of the device selected port master */
    device_selected_port_id!: number;
    /** The auto-generated id of the device port specification master master */
    device_model_port_specification_id!: number;
    /** The auto-generated id of the device port allocation master master */
    device_model_port_allocation_id!: number;
    /** The reading type should be "Direct" or "Inverse" */
    reading_type!: string;
    /** The work hour calculation should be 1 or 0 */
    work_hour_calculation!: number;
    /** Manage status of selected device port. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ISelectedPortOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_selected_port_id = _data["device_selected_port_id"];
            this.device_model_port_specification_id = _data["device_model_port_specification_id"];
            this.device_model_port_allocation_id = _data["device_model_port_allocation_id"];
            this.reading_type = _data["reading_type"];
            this.work_hour_calculation = _data["work_hour_calculation"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SelectedPortOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedPortOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_selected_port_id"] = this.device_selected_port_id;
        data["device_model_port_specification_id"] = this.device_model_port_specification_id;
        data["device_model_port_allocation_id"] = this.device_model_port_allocation_id;
        data["reading_type"] = this.reading_type;
        data["work_hour_calculation"] = this.work_hour_calculation;
        data["status"] = this.status;
        return data; 
    }
}

export interface ISelectedPortOutput {
    /** The auto-generated id of the device selected port master */
    device_selected_port_id: number;
    /** The auto-generated id of the device port specification master master */
    device_model_port_specification_id: number;
    /** The auto-generated id of the device port allocation master master */
    device_model_port_allocation_id: number;
    /** The reading type should be "Direct" or "Inverse" */
    reading_type: string;
    /** The work hour calculation should be 1 or 0 */
    work_hour_calculation: number;
    /** Manage status of selected device port. 0 For De-active, 1 For Active */
    status: number;
}

